import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { Fragment, useState } from 'react';

import { LoadingSkeleton } from 'components';

import AddLinkedMemberDialog from './AddLinkedMemberDialog';
import LinkedMembersContent from './LinkedMembersContent';

const LinkedMembers = ({ members, loading, isAllowedToAdd }) => {
	const [dialogOpen, setDialogOpen] = useState(false);

	const openDialog = () => setDialogOpen(true);
	const closeDialog = () => setDialogOpen(false);

	return (
		<Fragment>
			<Stack spacing={2}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						Linked Members:
					</Typography>
					<IconButton disabled={loading || !isAllowedToAdd} onClick={openDialog}>
						<AddIcon />
					</IconButton>
				</Box>
				<LoadingSkeleton isLoading={loading}>
					<LinkedMembersContent members={members} />
				</LoadingSkeleton>
			</Stack>
			<AddLinkedMemberDialog isOpen={dialogOpen} onClose={closeDialog} isAllowedToAdd={isAllowedToAdd} />
		</Fragment>
	);
};

export default LinkedMembers;
